/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import PAGES_TYPE from 'shared-constants/src/pagesType';
import casaClaim from 'shared-constants/src/header_footer/casaClaim';

import makeClassName from 'shared-utils/src/makeClassName';

import trackGTMEvents from 'shared-utils/src/trackGTMEvents/new';
import getActiveFilters, { getActiveFiltersCountWithPTypes } from 'shared-utils/src/getActiveFilters';

import LazyLoad from 'shared-components/components/LazyLoad';

import GoToTop from '@async-components/GoToTop';

import reducerSearch from '@state/reducers/search';
import selectorSearch from '@state/selectors/search';

import SectionPublish from '@components/homePage/SectionPublish';

import { CtxContainer } from '@client/app/Container';

import App from '../app/App';
import MetaInfo from '../components/common/metainfo/MetaInfo';

import Locality from '../components/homePage/Locality';
import ResetButton from '../components/homePage/ResetButton';
import FiltersButton from '../components/homePage/FiltersButton';
import Select from '../components/homePage/Select';
import PTypes from '../components/homePage/Ptypes';
import SearchButton from '../components/homePage/SearchButton';
import AnimatedSplash from '../components/homePage/AnimatedSplash';
import CasaForYou from '../components/homePage/CasaForYou';
import CasaSEOPresentation from '../components/homePage/CasaSEOPresentation';
import CasaApp from '../components/homePage/CasaApp';
import BlogPosts from '../components/homePage/BlogPosts';
import SeoFooter from '../components/homePage/SeoFooter';
import RecentSearches from './RecentSearches';
import AuctionSplash from '../components/homePage/AuctionSplash/index';

import {
  isChildOf,
  scrollToTop,
} from '../helpers/DOMHelpers';

import syncMyCasaCollections from 'shared-utils/src/syncMyCasaCollections';
import { getCollectionNode } from 'shared-utils/src/myCasaCollections';
import { MY_COLLECTIONS_TYPES, MY_COLLECTIONS_IDS } from 'shared-constants/src/mycasa26/collection_configurations';

import './HomePageSearch-critical.scss';
import './HomePageMore-critical.scss';

import {
  categoryFilter,
  channelFilter,
  casaForYouContentList,
  casaPresentationContentList,
} from '../constants/restyling';

import getProvinceLocationFromTown from '../helpers/search/getProvinceLocationFromTown';
import syncMinHeightVar from '../helpers/syncMinHeightVar';

class Home extends PureComponent {
  static contextType = CtxContainer;

  constructor(props) {
    super(props);
    this.state = {
      availablePoi: props.home.availablePoi,
      openSelect: null,
      loadCasaAppImg: false,
      config: props.config,
      resetButtonCoords: {
        top: null,
        left: null,
        mobLeft: null,
      },
      recentSearches: props.recentSearches,
    };
  }

  componentDidMount() {
    this.trSelect = document.querySelector('#trSelect');
    this.locationInput = document.querySelector('#locationInput');
    this.searchButtonEl = document.querySelector('#searchButton');
  }

  componentWillReceiveProps(nextProps) {
    const {
      device,
      home,
      availablePois,
      mainLocation,
      filters,
      viewport,
      recentSearches: nextRecentSearches,
      user,
      user: {
        isAuthenticated: newAuthState,
      }
    } = nextProps;

    const {
      availablePois: oldAvailablePois,
      mainLocation: oldMainLocation,
      filters: oldFilters,
      viewport: oldViewport,
      recentSearches: oldRecentSearches,
      user: {
        isAuthenticated: oldAuthState,
      }
    } = this.props;

    if (device === 'desktop') {
      window.addEventListener('click', evt => this.searchElementsBehaviour(evt));
    }
    syncMinHeightVar(device, viewport);

    if (nextRecentSearches !== oldRecentSearches) {
      this.setState({ recentSearches: nextRecentSearches });
    }

    if (!oldAuthState && newAuthState) {
      this.syncUserData(user);
    }

    if (oldViewport.width !== viewport.width) {
      this.updateLayoutBounduaries();
    }

    if (!home.isFetchingResults) {
      if (home.availablePoi) {
        this.setState({
          availablePoi: home.availablePoi,
        });
      } else {
        this.setState({
          availablePoi: [],
        });
      }
    }

    if (availablePois !== oldAvailablePois) {
      if (availablePois) {
        this.setState({
          availablePoi: availablePois,
        });
      } else {
        this.setState({
          availablePoi: [],
        });
      }
    }

    if (!oldMainLocation && mainLocation) {
      this.computeLayoutBounduaries(true, filters.propertyTypes.length > 0);
    }

    if (
      oldMainLocation
      && (
        oldFilters.tr !== filters.tr
        || oldFilters.propertyTypeGroup !== filters.propertyTypeGroup
        || oldFilters.propertyTypes !== filters.propertyTypes
      )
    ) {
      this.computeLayoutBounduaries(false, filters.propertyTypes.length > 0);
    }
  }

  updateLayoutBounduaries = () => {
    const { filters } = this.props;
    this.computeLayoutBounduaries(false, filters.propertyTypes.length > 0);
  }

  computeLayoutBounduaries = (render = false, hasPtypes = false) => {
    const timing = render
      ? 75
      : 10;

    setTimeout(() => {
      const cont = document.querySelector('#searchContainer');
      const elements = document.querySelectorAll('.sentenceElement');
      const firstSelect = elements[0].querySelectorAll('.hpsb__und')[0];

      const contW = cont.getBoundingClientRect().width;
      const adjust = document.documentElement.clientWidth < 1024 ? 0 : (document.documentElement.clientWidth - contW) / 2;

      const yCoords = [];
      const xCoords = [];

      elements.forEach(
        (el) => {
          const { top, left, width } = el.getBoundingClientRect();
          top && yCoords.push(Math.ceil(top));
          if (yCoords.length && Math.ceil(top) === yCoords[0]) {
            left && xCoords.push(Math.ceil(left - adjust) + Math.ceil(width + 16));
          }
        },
      );

      const top = `${Math.min(...yCoords) - 24}px`;
      let left = Math.max(...xCoords) - 55 - 16;
      if (left + 110 > document.documentElement.clientWidth - (document.documentElement.clientWidth - contW)) {
        left -= 55;
      }

      const mob = firstSelect.getBoundingClientRect();
      let mobLeft = Math.ceil(mob.left - adjust - 16) + Math.ceil(mob.width) - 55;
      if (mobLeft + 110 > contW - 32) {
        mobLeft = contW - 32 - 110;
      }

      this.setState({
        resetButtonCoords: {
          top,
          left: `${left}px`,
          mobLeft: `${mobLeft}px`,
        },
      });
    }, timing);
  };

  /* LAYOUT BEHAVIOUR */

  /**
    * @desc search elements behaviour on user clicks: closes open select when the user clicks outside of it or removes focus on input field when the user clicks outside of it
    *
    * @param object $evt - click event
    *
    * @fires setState
  */

  searchElementsBehaviour = (evt) => {
    const { openSelect } = this.state;
    const propertyTypeGroupSelect = document.querySelector('#propertyTypeGroupSelect');

    let condition = null;
    if (propertyTypeGroupSelect) {
      condition = (
        openSelect !== null
        && !isChildOf(evt.target, document.querySelector('#propertyTypeGroupSelect'))
        && !isChildOf(evt.target, document.querySelector('#trSelect'))
      );
    } else {
      condition = (
        openSelect !== null
        && !isChildOf(evt.target, document.querySelector('#trSelect'))
      );
    }

    if (condition) {
      this.setState({ openSelect: null });
    }
  }

  /**
    * @desc toggles clicked select & closes the open select if it's different from clicked one & removes focus on input field
    *
    * @param string $which - name of the filter updated by select
    *
    * @fires setState
  */

  onToggleSelect = (which) => {
    const { openSelect } = this.state;
    if (openSelect !== null) {
      if (which !== openSelect) {
        this.setState({
          openSelect: which,
        });
      } else {
        this.setState({
          openSelect: null,
        });
      }
    } else {
      this.setState({
        openSelect: which,
      });
    }
  }

  storeSelectValue = (newFilters) => {
    const { setFilters } = this.props;
    setFilters(newFilters);
    this.setState({ openSelect: null });
  }

  updateGlobalState = (state, clb) => this.setState(state, clb);

  globalReducer = async (type, payload) => {
    const newState = await reducerSearch(this.state, type, payload);
    this.setState(newState);
  }

  globalSelector = type => selectorSearch(this.state, type)

  ptypesSelectFromModal = (newVal) => this.globalReducer('ptypesSelectFromModal', newVal);

  syncUserData = async () => {
    const { state: { config: { api: { portal26: portal26Domain } } } } = this;
    await syncMyCasaCollections({ portal26Domain, mergeAddresses: true });
    const searchHistory = getCollectionNode(MY_COLLECTIONS_TYPES.SEARCHES, MY_COLLECTIONS_IDS.RECENT)?.data || [];
    if (searchHistory.length) {
      this.setState({ recentSearches: searchHistory });
    }
  };

  render() {
    const {
      device,
      viewport,
      mobileOs,
      orientation,
      isSafari,
      config: {
        siteUrl,
        smartSuggest,
        api: {
          account,
        },
        apiEndPoints: {
          mycasaUser,
        },
        mycasaLinks,
        remote: {
          LocalitiesWithAgencyZones,
        },
      },
      home,
      home: {
        ogData,
        domain,
        blogPosts,
        seoFooter,
        seoFooterRent,
        seoFooterBigCities,
        categoryMenuValues,
        pTypesMenuValues,
        totalSeoFooter,
        numRoomMenuValues,
        licenseTypeGroupMenuValues,
        isSEOFooterHP,
        ptgrpsAggregates,
        queryFilters,
      },
      user,
      modal,
      modalData,
      seoData,
      rawQObject,

      filters,
      filters: {
        tr = '',
        propertyTypeGroup = '',
      },
      locations,
      parentLocation,
      mainLocation,
      additionalLocations,
      setFilters,
      setLocations,
      setNearby,
      submit,
      resetAll,
      getAvailableResults,
      isFetching,
      availableResults,
      hasLSSearch,
      filtersDialog,
      setFiltersDialog,
      setResetDialog,
      startWithSelectedPtypes,
      isLocalStorageAvailable,
      setEraseAddressesDialog,
      activeFiltersOnSSr,
    } = this.props;

    const {
      openSelect,
      resetButtonCoords,
      recentSearches,
    } = this.state;

    const pageData = {
      ogData: ogData || [],
      filtersDialog,
      filtersProps: {
        device,
        viewport,
        orientation,
        mobileOs,
        isSafari,
        isAgencyHome: false,
        isPublisherPage: false,
        isPublisherHP: false,
        isAgencySrp: false,

        publisherName: null,
        publisherId: null,
        publisherLocs: [],
        publisherLocsNumber: 0,

        agencyFreetext: null,
        localitiesWithAgencyZones: LocalitiesWithAgencyZones,

        filters: {
          ...filters,
        },
        locations,
        parentLocation,
        mainLocation,
        additionalLocations,
        selNearBy: filters.nearby,
        setFilters,
        setLocations,
        setCurrentNearby: setNearby,
        availableResults,
        getAvailableResults,
        ptgrpsAggregates,
        submitSearch: submit,
        getActiveFilters,
        getActiveFiltersCountWithPTypes,
        hpValuesReset: resetAll,
        startWithSelectedPtypes,
        ptypesSelectFromModal: this.ptypesSelectFromModal,
        setEraseAddressesDialog,
        activeFiltersOnSSr,
        getProvinceLocationFromTown,
      },
      openSelect,
    };

    const appProps = {
      ...this.props,
      pageData,
      pageType: PAGES_TYPE.HOME_PAGE,
      updateGlobalState: this.updateGlobalState,
      globalState: this.state,
      globalReducer: this.globalReducer,
      globalSelector: this.globalSelector,
      trackEvents: trackGTMEvents,
      isLocalStorageAvailable,
      isAuthenticated: user.isAuthenticated,
      userIsChecked: user.checked,
    };

    const logo = isSEOFooterHP
      ? (
        <a
          href={`${siteUrl}/`}
          title={casaClaim}
          className="logo"
          aria-label="Torna alla homepage di Casa.it"
        >
          {casaClaim}
        </a>
      ) : (
        <span className="logo">
          {casaClaim}
        </span>
      );

    const searchContainerClassName = makeClassName([
      device === 'tablet' && 'tablet',
      openSelect !== null && 'choosing',
      (propertyTypeGroup.length + tr.length >= 17) && 'centered',
    ]);

    const onlyAuction = home?.filters?.isAuction === true;

    return (
      <App {...appProps}>
        <MetaInfo
          domain={domain}
          seoData={seoData}
          homeRent={home.filters.tr === 'affitto'}
        />
        <main>
          <div
            id="splash"
            className={onlyAuction ? 'auctionHP' : propertyTypeGroup}
            onClick={e => device !== 'desktop'
              ? this.searchElementsBehaviour(e)
              : null
            }
          >
            <AnimatedSplash category={onlyAuction ? 'aste' : propertyTypeGroup} />
            {
              onlyAuction ? (
                <AuctionSplash total={totalSeoFooter} />
              )
                : (
                  <>
                    <div className={openSelect !== null ? 'identity short' : 'identity'}>
                      {logo}
                      <p aria-hidden="true">La casa per te è qui</p>
                    </div>
                    <div
                      id="searchContainer"
                      className={searchContainerClassName}
                      role="region"
                      aria-label="Inizia la ricerca del tuo immobile"
                    >
                      <ResetButton
                        locations={locations}
                        filters={filters}
                        reset={resetAll}
                        setResetDialog={setResetDialog}
                        coords={resetButtonCoords}
                      />
                      {filters.propertyTypes.length === 0 ? (
                        <Select
                          scope="propertyTypeGroup"
                          label="Cerco"
                          value={propertyTypeGroup}
                          matchValue={tr}
                          values={categoryFilter}
                          isOpen={openSelect === 'propertyTypeGroup'}
                          toggleSelect={this.onToggleSelect}
                          storeSelectValue={this.storeSelectValue}
                          visible
                          availableResults={availableResults}
                          activeFilters={getActiveFilters(filters)}
                          device={device}
                        />
                      ) : (
                        <PTypes
                          propertyTypes={filters.propertyTypes}
                          licenseTypeGroups={filters.licenseTypeGroups}
                          availableResults={availableResults}
                        />
                      )}
                      <Select
                        scope="tr"
                        label="in"
                        value={tr}
                        matchValue={propertyTypeGroup}
                        values={channelFilter}
                        isOpen={openSelect === 'tr'}
                        toggleSelect={this.onToggleSelect}
                        storeSelectValue={this.storeSelectValue}
                        device={device}
                      />
                      <Locality
                        device={device}
                        mainLocation={mainLocation}
                        additionalLocations={additionalLocations}
                        filters={filters}
                        smartSuggest={smartSuggest}
                        setLocations={setLocations}
                        setCurrentNearby={setNearby}
                        submitSearch={submit}
                      />
                      <FiltersButton
                        filters={filters}
                        locations={locations}
                        hasLSSearch={hasLSSearch}
                        submitSearch={submit}
                        setDialog={setFiltersDialog}
                        updateFilters={setFilters}
                        qObjectForCount={rawQObject}

                      />
                      <SearchButton
                        device={device}
                        category={propertyTypeGroup}
                        categoryValues={categoryFilter}
                        availableResults={availableResults}
                        submitSearch={submit}
                        isFetching={isFetching}
                        locations={locations}
                        filters={filters}
                      />
                    </div>
                    {recentSearches && <RecentSearches searches={recentSearches} />}
                  </>)
            }
          </div>
          {
            !onlyAuction && (
              <div ref={(node) => { this.publishBand = node; }}>
                <SectionPublish action={user.isAuthenticated ? `${siteUrl}/pubblica/annunci` : `${siteUrl}/pubblica-annunci`} />
              </div>
            )
          }
          {
            !isSEOFooterHP
            && (
              <section
                id="casaforyou"
                className="homeslice"
                aria-labelledby="casa-per-te"
              >
                <CasaForYou
                  device={device}
                  viewport={viewport}
                  contentList={casaForYouContentList}
                  trackEvents={trackGTMEvents}
                  user={user}
                  userUrls={{
                    accounthost: account,
                    userhost: mycasaUser,
                    links: mycasaLinks,
                  }}
                  siteUrl={siteUrl}
                />
              </section>
            )
          }
          {
            !isSEOFooterHP
            &&
            <LazyLoad>
              {(visible, setRef) => (
                <CasaApp
                  device={device}
                  isIos={mobileOs === 'ios'}
                  visible={visible}
                  setRef={setRef}
                  imgPath="https://www.casa.it/external-resources/common_images/common/"
                />
              )}
            </LazyLoad>
          }
          <section
            id="casapresentation"
            className={isSEOFooterHP ? 'homeslice seofooter' : 'homeslice'}
            aria-label="Chi siamo"
          >
            <CasaSEOPresentation
              baseUrl={appProps.config.baseUrl}
              device={device}
              contentList={casaPresentationContentList}
            />
          </section>
          {
            !isSEOFooterHP
            && blogPosts
            && blogPosts.length > 0
            &&
            <LazyLoad>
              {(visible, setRef) => (
                <BlogPosts
                  device={device}
                  viewport={viewport}
                  blogList={blogPosts}
                  setRef={setRef}
                  loadBlogImages={visible}
                />
              )}
            </LazyLoad>

          }
          <SeoFooter
            device={device}
            orientation={orientation}
            channel={home.filters.tr}
            category={home.filters.propertyTypeGroup}
            propertyType={home.filters.propertyType}
            numRooms={home.filters.rooms}
            condition={'condition' in home.filters ? home.filters.condition : null}
            onlyAuction={home.filters.isAuction === true}
            seoFooter={seoFooter}
            seoFooterRent={seoFooterRent}
            categoryMenuValues={categoryMenuValues}
            pTypesMenuValues={pTypesMenuValues}
            numRoomMenuValues={numRoomMenuValues}
            licenseTypeGroupMenuValues={licenseTypeGroupMenuValues}
            seoFooterBigCities={seoFooterBigCities}
          />
          {(device !== '' && device !== 'smartphone') && <GoToTop action={scrollToTop} vh={viewport?.height || 0} />}
        </main>
      </App>
    );
  }
}

export default Home;

Home.propTypes = {
  device: PropTypes.string,
  viewport: PropTypes.instanceOf(Object),
  isLocalStorageAvailable: PropTypes.bool,
  mobileOs: PropTypes.string,
  orientation: PropTypes.string,
  home: PropTypes.instanceOf(Object),
  config: PropTypes.instanceOf(Object),
  location: PropTypes.instanceOf(Object),
  actions: PropTypes.instanceOf(Object),
  user: PropTypes.instanceOf(Object),
  userLogIn: PropTypes.func,
  userLogOut: PropTypes.func,
  modal: PropTypes.bool,
  modalData: PropTypes.instanceOf(Object),
  seoData: PropTypes.instanceOf(Object),
  intl: PropTypes.instanceOf(Object),
  recentSearches: PropTypes.instanceOf(Array),
};

Home.defaultProps = {
  device: '',
  viewport: {},
  isLocalStorageAvailable: false,
  mobileOs: '',
  orientation: '',
  home: {},
  config: {},
  location: {},
  actions: {},
  user: {},
  userLogIn: () => { },
  userLogOut: () => { },
  modal: false,
  modalData: {},
  seoData: {},
  intl: {},
  recentSearches: null,
};
